<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :isModalVisible="modal.LKI01"
        :cardContentFlower="Flwimage"
        :cardContent="content"
        :CheckWidth="CheckWidth"
        :cardType="type"
        :openModal="openModal"
        :score="scoreTest"
      />
      <CardPopupInfoTranparent
        :isAddQueueShow="modal.LKA01"
        :cardContent="FlwData"
        :cardContentPaht="content"
        :CheckWidth="CheckWidth"
        :cardType="type"
        @updateUser="funcRoute"
      />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardPopupImg from './components/CardPopupImg.vue';
import CardPopupInfoTranparent from './components/CardpopupInfoTranparent.vue';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseIcon.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardPopupImg, CardPopupInfoTranparent, LoadingMDL},
  name: 'LKA01',
  data() {
    return {
      CheckWidth: window.innerWidth.toString(),
      code: '',
      lang: '',
      content: {},
      Flwimage: '',
      FlwData: {},
      modal: {
        LKI01: true,
        LKA01: false,
      },
      score: 0,
      type: 'flower',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      MaxScore: [],
      MinimumScore: [],
      LessonID: 0,
      mode: {},
      assignmentTestScore: {},
      scoreTest: this.$store.getters[`necessary/getLKAScore`],
      courseSection: '',
      startTime: '',
      courseCode: '',
      condition: [],
      loading: true,
      v3Data: {},
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      // assignmentTest: 'template/getAssignmentTest',
      // getUserTemplate: 'template/getUserTemplate',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.checkScore(template);
      this.courseSection =
        this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'LKA01 Watcher Call');
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    assignmentTest: function (val) {
      this.assignmentTestScore = val;
      if (this.mode.assingmentmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else if (this.mode.posttestMode == true) {
        alert('posttestMode');
      } else if (this.mode.pretestMode == true) {
        alert('pretestMode');
      } else if (this.mode.testmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else {
        this.score = this.$store.getters['score/getPoint'];
      }
    },
  },

  mounted() {
    this.onLoad();
  },
  created() {},
  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.startTime = this.$helpers.getDateFormat();
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      const contentId = `LKA01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    openModal() {
      this.modal = {
        LKI01: false,
        LKA01: true,
      };
    },
    checkScore(data) {
      var Question = data.content.question;
      for (let i = 0; i < Question.length; i++) {
        this.MaxScore.push(Question[i].item[0].data);
        this.MinimumScore.push(Question[i].item[0].data++ + 1);
      }
      if (
        this.scoreTest >= this.MinimumScore[1] &&
        this.scoreTest <= this.MaxScore[2]
      ) {
        this.Flwimage = data.content.question[2].item[2].data;
        this.FlwData = data.content.question[2];
      } else if (
        this.scoreTest >= this.MinimumScore[0] &&
        this.scoreTest <= this.MaxScore[1]
      ) {
        this.Flwimage = data.content.question[1].item[2].data;
        this.FlwData = data.content.question[1];
      } else if (this.scoreTest >= 0 && this.scoreTest <= this.MaxScore[0]) {
        this.Flwimage = data.content.question[0].item[2].data;
        this.FlwData = data.content.question[0];
      } else if (this.scoreTest) {
        this.Flwimage = data.content.question[0].item[2].data;
        this.FlwData = data.content.question[0];
      } else {
        alert('Score Error!');
      }
    },
    funcRoute(path) {
      this.commitPayloadData(path);
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
        // this.$store.commit('v4/clearPayloadStack');
      }
    },
  },
};
</script>
<style></style>
